module.exports = __webpack_public_path__ + "static/bro3-623ca344f819a4cc755221ba788c326f.jpg";